import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import IntlUtil from '../../../utils/IntlUtil'

dayjs.extend(customParseFormat)

const anchorDate = '2000-12-31T03:24:00'

const getLocaleFormat = locale => {
  const activeLocale = locale || IntlUtil._locale || navigator.language

  if (typeof Intl?.DateTimeFormat?.prototype?.formatToParts === 'function') {
    const parts = new Intl.DateTimeFormat(activeLocale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(new Date(anchorDate))

    return parts
      .map(({ type, value }) => {
        if (type === 'year') return 'YYYY'
        if (type === 'month') return 'MM'
        if (type === 'day') return 'DD'
        return value
      })
      .join('')
  }

  const numericFormat = new Date(anchorDate).toLocaleDateString(activeLocale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })
  return numericFormat.replace('2000', 'YYYY').replace('12', 'MM').replace('31', 'DD')
}

const getMobileDateMask = locale => {
  return dayjs(anchorDate).format(getLocaleFormat(locale)).replace(/[0-9]/g, '#').split('')
}

const convertToStandardFormat = (dateToConvert, locale) => {
  return dayjs(dateToConvert, getLocaleFormat(locale), true).format('YYYY-MM-DD')
}

const resolveDateConstraints = (field = {}) => {
  let { max, minAge, maxAge, data: dataSettings } = field

  if (dataSettings && typeof dataSettings === 'string') {
    let parsedDataSettings
    try {
      parsedDataSettings = JSON.parse(dataSettings)
    } catch {
      parsedDataSettings = null
    }

    if (Array.isArray(parsedDataSettings) && parsedDataSettings.length > 0) {
      parsedDataSettings = parsedDataSettings[0]
    }

    if (
      parsedDataSettings &&
      typeof parsedDataSettings === 'object' &&
      !Array.isArray(parsedDataSettings)
    ) {
      max = max ?? parsedDataSettings.max
      minAge = minAge ?? parsedDataSettings.minAge
      maxAge = maxAge ?? parsedDataSettings.maxAge
    }
  }

  return { max, minAge, maxAge }
}

const isDateWithinConstraints = (value, field) => {
  const { max, minAge, maxAge } = resolveDateConstraints(field)
  const momentDate = dayjs(value)

  if (!momentDate.isValid()) return false

  if (max === 'now' && momentDate.isAfter(dayjs())) return false

  if (maxAge > 0) {
    const minMoment = dayjs().subtract(maxAge, 'year')
    if (momentDate.isBefore(minMoment)) return false
  }

  if (minAge > 0) {
    const maxMoment = dayjs().subtract(minAge, 'year')
    if (momentDate.isAfter(maxMoment)) return false
  }

  return true
}

export {
  getMobileDateMask,
  convertToStandardFormat,
  getLocaleFormat,
  resolveDateConstraints,
  isDateWithinConstraints,
}
